import { useContext, useEffect, useState } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import Modal from "components/ui/modal/modal";
import Button from "components/ui/controls/button/button";
import { createStyledButton } from "components/ui/controls/button/button-styles";
import { FaFileAlt, FaPlusCircle, FaEdit, FaTrashAlt, FaShieldAlt, FaBriefcase, FaClipboardList } from "react-icons/fa";
import Row from "components/ui/layout/row/row";
import Column from "components/ui/layout/column/column";
import { applyFormat } from "components/ui/ui-helpers";
import Dialogs from "components/ui/dialogs/dialogs";
import ContratPrecoSelect from "./ContratPrecoSelect";
import ContratPrevoyancePageModal from "pages/audit complet/situation professionnelle/modules/contrat prevoyance modal";
import ContratFraisProPageModal from "pages/audit complet/situation professionnelle/modules/contrat frais pro modal";
import DropDown from "components/ui/controls/drop-down/drop-down";
import "../../../../components/app/Extranet/ListeClients.css";
import "../../../../components/app/settings/settings.css";

// Composant moderne pour l'état vide 
export const EmptyStateMessage = () => {
  return (
    <div className="empty-state-container" style={{ paddingBottom: '16px' }}>
      <div className="empty-state-content">
        {/* Message d'information avec style InfoMessage */}
        <div className="settings-text-helper" style={{ marginTop: 0, marginBottom: '12px' }}>
          <p>💡 Aucun contrat Article 62 n'est actuellement souscrit. Cliquez sur le bouton "Ajouter un contrat" ci-dessus pour commencer.</p>
        </div>
        
        <div className="empty-state-illustration">
          <div className="empty-state-icon-bg">
            <FaClipboardList className="empty-state-icon" />
          </div>
          <div className="empty-state-decoration">
            <div className="decoration-dot decoration-dot-1"></div>
            <div className="decoration-dot decoration-dot-2"></div>
            <div className="decoration-dot decoration-dot-3"></div>
          </div>
        </div>
        
        <div className="empty-state-text">
          <h3 className="empty-state-title">
            Aucun contrat souscrit
          </h3>
          <p className="empty-state-subtitle">
            Commencez par ajouter votre premier contrat Article 62.
          </p>
        </div>
      </div>
    </div>
  );
};

function ContratPrecoModal(props) {
  const context = useContext(AppContext);
  const [modalOpen, setmodalOpen] = useState(false);
  const [modalContratPrevOpen, setmodalContratPrevOpen] = useState(false);
  const [modalContratFraisProOpen, setmodalContratFraisProOpen] = useState(false);

  useEffect(() => {
    // if(modalOpen===true)
    // {
    //   context.handleResetPrevoyanceSettings();
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);  return (
    <>
      <Row tpad>
        <Column style={{ flex: "0 0 auto", marginRight: "16px" }}>
          <Button
            {...createStyledButton("primary")}
            onClick={() => setmodalOpen(true)}
          >
            <FaPlusCircle style={{ marginRight: "8px" }} />
            Ajouter un contrat
          </Button>
        </Column>
      </Row>
      <Modal
        width="30%"
        height="50%"
        title="Ajouter un contrat"
        icon={<FaFileAlt />}
        visible={modalOpen}
        onClose={() => {
          setmodalOpen(false);
        }}
      >
        <ContratPrecoSelect
          visible={modalOpen}
          Outil={props.Outil}
          ClientConjoint={props.ClientConjoint}
          onClose={(typeContrat) => {
            setmodalOpen(false);
            if (typeContrat === "prevoyance") {
              setmodalContratPrevOpen(true);
            } else if (typeContrat === "fraisPro") {
              setmodalContratFraisProOpen(true);
            }
          }}
        />
      </Modal>
      <ContratPrevoyancePageModal
        AccessRemExpress={props.AccessRemExpress}
        visible={modalContratPrevOpen}
        Statut={"TNS Article 62"}
        Outil={props.Outil}
        PayeurPrime="Entreprise"
        ClientConjoint={props.ClientConjoint}
        CliConj={props.ClientConjoint}
        onClose={() => {
          setmodalContratPrevOpen(false);
        }}
      />
      <ContratFraisProPageModal
        AccessRemExpress={props.AccessRemExpress}
        visible={modalContratFraisProOpen}
        Outil={props.Outil}
        ClientConjoint={props.ClientConjoint}
        onClose={() => {
          setmodalContratFraisProOpen(false);
        }}
      />      {context.state.ContratEnregistre.length > 0 && context.state[props.Outil + "ContratEnregistre"].length === 0 && (
        <Row tpad>
          <table>
            <tbody>
            <tr>
              <td style={{ width: "350px" }}>Souhaitez vous conserver le(s) contrat(s) existant(s)</td>
              <td>
                <DropDown
                  style={{ marginTop: '16px' }}
                  value={"Non"}
                  onChange={ (e)=> e.target.value ==="Oui" && context.handlePrevTnsAddToPreco(props.Outil)}
                  options={[
                    { value: "Non", label: "Non" },
                    { value: "Oui", label: "Oui" },
                  ]}
                  normal
                />
              </td>
            </tr>
            </tbody>
          </table>
        </Row>
      )}

      <Row style={{ marginTop: '12px' }}>
        <div className="client-card-list" style={{ width: '100%', minHeight: '0', maxWidth: '100%', margin: 0, boxSizing: 'border-box', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: 8 }}>
          {/* Vérifier si aucun contrat n'est souscrit */}
          {context.state[props.Outil + "ContratEnregistre" + props.ClientConjoint].length === 0 &&
           context.state[props.Outil + "ContratFraisPro" + props.ClientConjoint].length === 0 && (
            <EmptyStateMessage />
          )}
          
          {context.state[props.Outil + "ContratEnregistre" + props.ClientConjoint].map((Infos, Index) => (
            <div key={"prevoyance-"+Infos.id} className="client-card" style={{ minHeight: 56, padding: '10px 12px' }}>
              <div className="client-card-main">
                <div className="client-card-info">
                  <div className="client-card-avatar" style={{ backgroundColor: '#dcfce7' }}>
                    <FaShieldAlt style={{ color: '#22c55e', fontSize: '16px' }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div className="client-card-row">
                      <h4 className="client-card-title">{Infos.LibelleContrat}</h4>
                    </div>
                    <div className="client-card-row">
                      <span style={{
                        display: 'inline-block',
                        background: '#dcfce7',
                        color: '#22c55e',
                        fontSize: 12,
                        fontWeight: 500,
                        borderRadius: 12,
                        padding: '2px 10px',
                        margin: '2px 0'
                      }}>Prévoyance - Article 62</span>
                    </div>
                    <div className="client-card-date">
                      {applyFormat(Number(Infos.PrevoyanceMadelin) + Number(Infos.PrevoyanceNonMadelin), "uint", { thousands: " ", decimal: ",", unit: " € / an" })}
                    </div>
                  </div>
                </div>
                <div className="client-card-actions" style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                  <Button
                    icon
                    {...createStyledButton("card-action", "cardEdit")}
                    onClick={() => {
                      context.handleModifyDeleteContratPrevoyance(Infos.id, "Modifier", "Prevoyance", props.Outil, props.ClientConjoint);
                      setmodalContratPrevOpen(true);
                    }}
                  >
                    <FaEdit className="editContratPreco" id={"contratFac"+Infos.id} style={{ color: "#22c55e", fontSize: "12px" }} />
                  </Button>
                  <Button
                    icon
                    {...createStyledButton("card-action", "delete")}
                    onClick={() => {
                      Dialogs.confirm(
                        "Vous êtes sur le point de supprimer le contrat.\nVoulez-vous continuer ?",
                        "Suppression du contrat",
                        () => {
                          context.handleModifyDeleteContratPrevoyance(Infos.id, "Supprimer", "Prevoyance", props.Outil, props.ClientConjoint);
                        }
                      );
                    }}
                  >
                    <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
                  </Button>
                </div>
              </div>
            </div>
          ))}
          
          {context.state[props.Outil + "ContratFraisPro" + props.ClientConjoint].map((Infos, Index) => (
            <div key={"fraispro-"+Infos.id} className="client-card" style={{ minHeight: 56, padding: '10px 12px' }}>
              <div className="client-card-main">
                <div className="client-card-info">
                  <div className="client-card-avatar" style={{ backgroundColor: '#e0e7ff' }}>
                    <FaBriefcase style={{ color: '#3730a3', fontSize: '16px' }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div className="client-card-row">
                      <h4 className="client-card-title">{Infos.LibelleContrat}</h4>
                    </div>
                    <div className="client-card-row">
                      <span style={{
                        display: 'inline-block',
                        background: '#e0e7ff',
                        color: '#3730a3',
                        fontSize: 12,
                        fontWeight: 500,
                        borderRadius: 12,
                        padding: '2px 10px',
                        margin: '2px 0'
                      }}>Frais professionnels - Article 62</span>
                    </div>
                    <div className="client-card-date">
                      {applyFormat(Number(Infos.FGPMontant), "uint", { thousands: " ", decimal: ",", unit: " € / an" })}
                    </div>
                  </div>
                </div>
                <div className="client-card-actions" style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                  <Button
                    icon
                    {...createStyledButton("card-action", "cardEdit")}
                    onClick={() => {
                      context.handleModifyDeleteContratPrevoyance(Infos.id, "Modifier", "Frais professionnels", props.Outil, props.ClientConjoint);
                      setmodalContratFraisProOpen(true);
                    }}
                  >
                    <FaEdit className="editContratPreco" id={"contratFac"+Infos.id} style={{ color: "#22c55e", fontSize: "12px" }} />
                  </Button>
                  <Button
                    icon
                    {...createStyledButton("card-action", "delete")}
                    onClick={() => {
                      Dialogs.confirm(
                        "Vous êtes sur le point de supprimer le contrat.\nVoulez-vous continuer ?",
                        "Suppression du contrat",
                        () => {
                          context.handleModifyDeleteContratPrevoyance(Infos.id, "Supprimer", "Frais professionnels", props.Outil, props.ClientConjoint);
                        }
                      );
                    }}
                  >
                    <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Row>
    </>
  );
}

export default ContratPrecoModal;
